import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import loaderGif from "../../assets/blogimage/loader.gif";
import { Badge, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdOutlineDateRange } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Nav from "../Navbar";
import Footer from "../Footer";
// import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";

const Article = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [blogData, setBlogData] = useState(null);
  const [postdata, setpostdata] = useState([]);
  const { post_slug } = useParams();
  console.log("Post Slug from URL:", post_slug);
  useEffect(() => {
    console.log(post_slug); 
    if (post_slug) {
      GetAuthorsBlog(post_slug);
    }
  }, [post_slug]);
  const GetAuthorsBlog = async (slug) => {
    setIsLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ slug: slug }),
        redirect: "follow",
      };

      const res = await fetch(
        `https://blogapi.bumppy.com/api/bumppy/GetProductBlogBySlug`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        setBlogData(data.data[0]);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          webid: "6",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `https://blogapi.bumppy.com/api/bumppy/GetAllProductBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setpostdata(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (blogData) {
      const images = document.querySelectorAll(".blog-content img");
      images.forEach((img) => {
        img.style.borderRadius = "1rem";
        img.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
        img.style.width = "100%";
        img.style.height = "auto";
      });
    }
  }, [blogData]);

  useEffect(() => {
    Getproductblogs();
  }, []);

  if (!blogData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
      </div>
    );
  }
  function cleanBlockContent(htmlString) {
    return htmlString.replace(/<\/?span[^>]*>/g, "");
  }

  return (
    <>
      <Helmet>
        <script src="https://seobix.com/schemaScript/jsonpackky.js"></script>
      </Helmet>
      <Container fluid className="p-0 " style={{ overflowX: "hidden" }}>
        {/* home */}

        <div>
          {/* <div
                    className="d-flex justify-content-center"
                    style={{ background: "#fdca40" }}
                    >
                    <p className="p-2 m-0 text-center">
                    Start with free trial of <b>SeoBix!</b>-boost your SEO
                    game&nbsp;&nbsp;{" "}
                    <Button size="sm" variant="success">
                    Know More
                    </Button>
                    </p>
                    </div> */}
          <Nav />
        </div>
        <div className="container p-0 ">
          <div className="mt-md-5 mt-3">
            <div className="row mx-md-0 mx-3 mt-sm-3">
              <div className="col-md-1 "></div>
              <div className="col m-0 p-0">
                <Container className="p-0">
                  <div className="row m-auto" style={{ height: "auto" }}>
                    <div
                      className="col-md-9 col-12 m-0 p-0 "
                      style={{
                        // height: "120vh",
                        overflowY: "auto",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                    >
                      <style>
                        {`
                          .hide-scrollbar::-webkit-scrollbar {
                          display: none;
                          }
                          `}
                      </style>

                      <div style={{ width: "95%" }}>
                        <div className="d-flex flex-wrap"></div>

                        <h1>{blogData.title}</h1>

                        <div className="row">
                          <p
                            className="col"
                            style={{
                              fontSize: ".9rem",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {blogData.author_url ? (
                              <img
                                src={blogData.author_url}
                                alt={blogData.author_url}
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  marginRight: "8px",
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display =
                                    "inline-block";
                                }}
                              />
                            ) : (
                              <FaUserTie
                                style={{
                                  fontSize: "1.3rem",
                                  color: "grey",
                                  marginRight: "8px",
                                }}
                              />
                            )}

                            <FaUserTie
                              style={{
                                fontSize: "1.3rem",
                                color: "grey",
                                marginRight: "8px",
                                display: "none",
                              }}
                            />

                            <Link
                              to={`/author/${blogData.author_slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                              onClick={() => {
                                const authorData = JSON.stringify(blogData);
                                console.log("click hua");
                                localStorage.setItem("author", authorData);
                              }}
                            >
                              {blogData.author_name}
                            </Link>
                          </p>
                          <p
                            className="col d-flex justify-content-end p-0"
                            style={{ fontSize: ".9rem" }}
                          >
                            <MdOutlineDateRange
                              style={{ fontSize: "1.3rem", color: "grey" }}
                            />
                            &nbsp;
                          </p>
                        </div>

                        <div>
                          <img
                            src={blogData.image_url}
                            alt={blogData.image_desc}
                            title={blogData.image_desc}
                            style={{
                              width: "100%",
                              height: "auto",
                              borderRadius: "1rem",
                            }}
                          />
                        </div>

                        <p className="pt-3" style={{ fontSize: "1rem" }}>
                          {blogData.excerpt}
                        </p>
                        <div className="blog-content mt-3">
                          <style>
                            {`
                              .blog-content a {
                              text-decoration: none;
                              }

                              .blog-content a:hover {
                              text-decoration: underline;
                              }
                              `}
                          </style>

                          {(() => {
                            const renderedContents = new Set();

                            return blogData.blocks?.map((block, index) => {
                              const cleanedContent = cleanBlockContent(
                                block.block_content
                              );
                              const type = block.block_type.toLowerCase();

                              if (
                                (type === "ul" || type === "ol") &&
                                cleanedContent
                              ) {
                                const tempDiv = document.createElement("div");
                                tempDiv.innerHTML = cleanedContent;
                                const paragraphs = Array.from(
                                  tempDiv.querySelectorAll("p")
                                );
                                paragraphs.forEach((p) =>
                                  renderedContents.add(p.innerHTML.trim())
                                );
                              }

                              if (
                                type === "p" &&
                                renderedContents.has(cleanedContent.trim())
                              ) {
                                return null;
                              }

                              const supportedTags = [
                                "h1",
                                "h2",
                                "h3",
                                "h4",
                                "h5",
                                "h6",
                                "p",
                                "ul",
                                "ol",
                                "li",
                                "blockquote",
                                "code",
                                "pre",
                                "div",
                                "span",
                                "strong",
                                "em",
                                "u",
                                "img",
                                "video",
                                "a",
                                "br",
                              ];

                              if (
                                (type === "p" || type.startsWith("h")) &&
                                cleanedContent.includes("<img") &&
                                blogData.blocks[
                                  index + 1
                                ]?.block_type.toLowerCase() === "img"
                              ) {
                                const nextImg =
                                  blogData.blocks[index + 1].block_image;
                                const match = cleanedContent.match(
                                  /<img[^>]+src="([^"]+)"/i
                                );
                                if (match && match[1] === nextImg) return null;
                              }

                              if (type === "img" && block.block_image) {
                                return (
                                  <div key={index} className="my-3 text-center">
                                    <img
                                      src={block.block_image}
                                      alt={block.block_image_alt || ""}
                                      title={block.block_image_title || ""}
                                      className="img-fluid"
                                      style={{
                                        maxWidth: "100%",
                                        height: "auto",
                                      }}
                                    />
                                    {block.block_image_desc && (
                                      <p
                                        className="mt-2 text-muted"
                                        style={{ fontStyle: "" }}
                                      >
                                        {block.block_image_desc}
                                      </p>
                                    )}
                                  </div>
                                );
                              }

                              if (supportedTags.includes(type)) {
                                return (
                                  <div
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                      __html: `<${type}>${cleanedContent}</${type}>`,
                                    }}
                                  />
                                );
                              }

                              return (
                                <p
                                  key={index}
                                  dangerouslySetInnerHTML={{
                                    __html: cleanedContent,
                                  }}
                                />
                              );
                            });
                          })()}
                        </div>

                        <div className="mb-2">
                          {[...(blogData.keyword || "").split(",")].map(
                            (keyword, index) =>
                              keyword.trim() && (
                                <span
                                  key={index}
                                  className="me-2 mb-2 d-inline-block"
                                  style={{
                                    backgroundColor: "#f0f0f0",
                                    border: "1px solid #b0b0b0",
                                    color: "#333",
                                    borderRadius: ".2rem",
                                    fontSize: ".8rem",
                                    padding: "0.25rem 0.5rem",
                                    marginLeft: ".4rem",
                                  }}
                                >
                                  {keyword.trim()}
                                </span>
                              )
                          )}
                        </div>
                        <div className="mb-4 px-2">
                          {(blogData.tag || "")
                            .split(",")
                            .filter((tag) => tag.trim())
                            .map((tag, index) => (
                              <Link
                                key={index}
                                to="/blog-section"
                                onClick={() => {
                                  sessionStorage.setItem(
                                    "tag",
                                    JSON.stringify(tag.trim())
                                  );
                                  sessionStorage.setItem("FromTag", "1");
                                }}
                                className="me-2 mb d-inline-block text-decoration-none px-2"
                              >
                                #{tag.trim()}
                              </Link>
                            ))}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-12 p-md-0 p-0">
                      <h6 className="mt-3 text-center">Related Blogs</h6>

                      <div
                        className="related-blogs-scroll mt-5"
                        style={{
                          maxHeight: "100vh",
                          overflowY: "auto",
                          // paddingRight: "10px",
                        }}
                      >
                        {postdata.map((blog) => (
                          <div
                            key={blog.id}
                            className="d-flex align-items-center mb-3"
                            style={{ width: "100%" }}
                          >
                            <img
                              src={blog.image_url}
                              alt={blog.image_alt || "Blog Image"}
                              style={{
                                width: "60px",
                                height: "60px",
                                // borderRadius: "50%",
                                marginRight: "1rem",
                                flexShrink: 0,
                              }}
                            />

                            <a
                              href={`/blog/${blog.slug}`}
                              onClick={() => {
                                sessionStorage.setItem(
                                  "Slug",
                                  JSON.stringify(blog)
                                );
                              }}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                width: "100%",
                              }}
                            >
                              <div style={{ textAlign: "start" }}>
                                <p
                                  style={{
                                    fontSize: ".8rem",
                                    margin: 0,
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: "100%",
                                  }}
                                >
                                  {blog.title.split(" ").slice(0, 7).join(" ") +
                                    (blog.title.split(" ").length > 7
                                      ? "..."
                                      : "")}
                                </p>

                                <p
                                  style={{
                                    fontSize: ".8rem",
                                    color: "#686D76",
                                    margin: 0,
                                    fontWeight: "600",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {blog.author_image ? (
                                    <img
                                      src={blog.author_image}
                                      alt={blog.author_name}
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        marginRight: "6px",
                                      }}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = "none";
                                        e.target.nextSibling.style.display =
                                          "inline-block";
                                      }}
                                    />
                                  ) : (
                                    <FaUserTie
                                      style={{
                                        fontSize: ".9rem",
                                        color: "grey",
                                        marginRight: "6px",
                                      }}
                                    />
                                  )}
                                  <span
                                    style={{
                                      display: blog.author_image
                                        ? "inline"
                                        : "inline-block",
                                    }}
                                  >
                                    {blog.author_name}
                                  </span>
                                </p>
                              </div>
                            </a>
                          </div>
                        ))}
                      </div>

                      {/* Hide scrollbar CSS */}
                      <style>
                        {`
                          .related-blogs-scroll::-webkit-scrollbar {
                          display: none;
                          }
                          .related-blogs-scroll {
                          -ms-overflow-style: none; /* IE and Edge */
                          scrollbar-width: none; /* Firefox */
                          }
                          `}
                      </style>
                    </div>
                  </div>
                </Container>
              </div>

              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background: "#31393C",
            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        ></div>
      </Container>
      <Footer />
    </>
  );
};

export default Article;
